"use strict";

exports.__esModule = true;
exports.FieldControl = void 0;
var _react = _interopRequireWildcard(require("react"));
var _InputCounter = require("../InputCounter/InputCounter");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-undef */
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for a form field
 */
const FieldControl = ({
  forwardedRef,
  name,
  id,
  promptText,
  value,
  disabled,
  readOnly,
  error,
  isNumber,
  inputMode,
  maxLength,
  isStrict,
  stateManaged,
  onBlur,
  onChange,
  onFocus,
  type = 'text',
  ...props
}) => {
  const inputRef = forwardedRef;

  // get the input length and set it, 0 by default
  // updates on change
  const [currentLength, setCurrentLength] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    // get the value count, only called after initial render
    setCurrentLength(inputRef.current.value.length);
  }, []);
  function filterInput(e) {
    // entered value
    let checkThis = e.key;

    // check data being pasted
    if (e.type === 'paste') {
      // Get pasted data via clipboard API
      const clipboardData = e.clipboardData || window.clipboardData;
      checkThis = clipboardData.getData('Text');
    }
    const regex = /^\d+$/;
    if (!regex.test(checkThis)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  // controlled vs uncontrolled method
  const stateManagedAttr = stateManaged ? {
    value,
    onBlur,
    onChange: isNumber ? e => {
      setCurrentLength(inputRef.current.value.length);
      onChange(e);
    } : onChange
  } : {
    defaultValue: value,
    onChange: isNumber ? () => {
      setCurrentLength(inputRef.current.value.length);
    } : undefined
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `ccl__field-control`,
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "ccl__field-control__input ccl__text ccl__text--body-text",
      ref: inputRef,
      name: name,
      id: id || name,
      type: type,
      placeholder: promptText,
      disabled: disabled,
      readOnly: readOnly,
      inputMode: inputMode,
      maxLength: maxLength > 0 ? maxLength : undefined,
      onFocus: onFocus,
      onKeyPress: event => isStrict && filterInput(event),
      onPaste: event => isStrict && filterInput(event),
      ...stateManagedAttr
    }), isNumber && maxLength > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputCounter.InputCounter, {
      currentLength: currentLength,
      requiredLength: maxLength
    })]
  });
};
exports.FieldControl = FieldControl;
FieldControl.defaultProps = {
  id: '',
  promptText: '',
  value: '',
  error: false,
  disabled: false,
  readOnly: false,
  forwardedRef: undefined,
  isNumber: false,
  inputMode: 'text',
  maxLength: undefined,
  isStrict: false,
  stateManaged: true,
  onChange: () => {},
  onBlur: () => {}
};